import { render, staticRenderFns } from "./SearchDownloadHeader.vue?vue&type=template&id=50ee813b&scoped=true&"
import script from "./SearchDownloadHeader.vue?vue&type=script&lang=js&"
export * from "./SearchDownloadHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchDownloadHeader.vue?vue&type=style&index=0&id=50ee813b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ee813b",
  null
  
)

export default component.exports